var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datacollection)?_c('div',{staticClass:"vacancy-stat"},[_c('VacancyStatMultiChart',{attrs:{"chart-data":_vm.datacollection,"height":150}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }